import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { virtual } from 'haunted';
import { sanitizeHtml } from '@local/sanitize-html';

export const mediaTmpl = virtual(({ videoId, description, title }) => {
  return html`
    <div>
      <div class="flex justify-center">
        <div class="w-full max-w-3xl aspect-video">
          <iframe
            class="w-full h-full"
            width="560"
            height="315"
            src="https://www.youtube-nocookie.com/embed/${videoId}"
            title="${title || 'YouTube video'}"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          >
          </iframe>
        </div>
      </div>
      <div class="p-6 mt-2">${unsafeHTML(sanitizeHtml(description))}</div>
    </div>
  `;
});
